const IsPc = () => {
  if(document.body) {
    return document.body.clientWidth > 768
  } else {
    return true
  }
};

const throttle = (fn, timeout) => {
  let isPending = false;
  return (...arg) => {
    if (isPending) return;
    isPending = true;
    fn.call(this, ...arg);
    setTimeout(() => {
      isPending = false;
    }, timeout);
  };
};
const debounce = (fn, wait) => {
  var timeout = null;
  return (...arg) => {
    if (timeout !== null) clearTimeout(timeout);
    timeout = setTimeout(fn.bind(this, ...arg), wait);
  };
};

// document.addEventListener('DOMContentLoaded', function() {
//   document.removeEventListener("DOMContentLoaded",arguments.callee,false)
//   if(window.onready) {
//     window.onready()
//   }
// }, false)
(function () {
  let time = setInterval(() => {
    if (typeof $ == "function") {
      clearInterval(time);
      document.dispatchEvent(new CustomEvent("jquery:ready", $));
    }
  }, 100);
})();

function addLoadEvent(func) {
  window.addEventListener("load", func);
}

function addJqueryReadyCallBack(func) {
  document.addEventListener("jquery:ready", func);
}

const addReadyAndResizeEvent = (function () {
  return function (func, loaded = false) {
    if (loaded) {
      addLoadEvent(func);
    } else {
      addJqueryReadyCallBack(func);
    }

    window.addEventListener(
      "resize",
      (function () {
        let lastIsPc = IsPc();
        return debounce(() => {
          if (IsPc() != lastIsPc) {
            func();
            lastIsPc = IsPc();
          }
        }, 50);
      })()
    );
  };
})();

// function initialImage(){
//   return ()=>{}
// }

addLoadEvent(function() {
  let el = $("#shopify-section-161243637626b484f7")
  el.find(".hero__image").css("cursor", "pointer")
  el.click(function () {
    $(".site-footer").get(0).scrollIntoView()
    // window.scrollTo(0)
  })
})


// // (function(){
//   let id = setInterval(function(){
//     if($(".fb_customer_chat_icon").length>0) {
//       if (!IsPc()) { 
//         $(".fb_customer_chat_icon").css('right', '')
//         $(".fb_customer_chat_icon").css({ bottom: "24px", left: "20px" })
//       } else {
//         $(".fb_customer_chat_icon").css({ bottom: "24px" })
//       }
//       clearInterval(id)
//     }
//   },500)
// // })()

